{
  "title": "Shape Water",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "S",
  "duration": "Instantaneous or 1 hour",
  "description": [
    "You choose an area of water that you can see within range and that fits within a 5-foot cube. You manipulate it in one of the following ways:",
    "You instantaneously move or otherwise change the flow of the water as you direct, up to 5 feet in any direction. This movement doesn’t have enough force to cause damage.",
    "You cause the water to form into simple shapes and animate at your direction. This change lasts for 1 hour.",
    "You change the water’s color or opacity. The water must be changed in the same way throughout. This change lasts for 1 hour.",
    "You freeze the water, provided that there are no creatures in it. The water unfreezes in 1 hour.",
    "If you cast this spell multiple times, you can have no more than two of its non-instantaneous effects active at a time, and you can dismiss such an effect as an action."
  ],
  "spellLists": ["druid", "eldritch-knight", "arcane-trickster", "sorcerer", "wizard"]
}
